import type { ImageTextGridContent } from '@/core/types';

import { ImageTextGrid } from '@/containers/blocks/image-text';

export default function generate({
  content,
  className,
}: {
  content: ImageTextGridContent;
  className?: string;
}) {
  return (
    <ImageTextGrid
      title={content.title}
      description={content.description}
      items={content.items}
      className={className}
    />
  );
}
